<template>
    <div v-b-visible.once="embedVisible">
        <div v-if="visible">
            <b-embed v-if="data.imageType == 'application/pdf'"
                     v-b-visible.once="embedVisible"
                     :src="data.imgSrc"
                     type="embed"/>
            <b-img-lazy v-else :src="data.imgSrc" fluid/>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, VModel, Vue} from "vue-property-decorator";

    @Component({
        name: "IngestionImage"
    })
    export default class IngestionImage extends Vue {
        @VModel() private data!: any;
        private visible = false;

        embedVisible(vis: boolean) {
            console.log("imgSrc: ", this.data.imgSrc);
            if (vis) this.visible = vis;
        }

    }
</script>

<style scoped>

</style>
